const pageBody = document.body;
const apiKey = 'b0a29e7c792a4ec0951203818250408';

const cities = [
  { name: "Chicago, IL", query: "Chicago" },
  { name: "Los Angeles", query: "Los Angeles" },
  { name: "London", query: "London" }
];

const container = document.getElementById('weather-container');

function capitalizeWords(str) {
  return str.replace(/\b\w/g, c => c.toUpperCase());
}

function formatTime(date) {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  return (
    String(hours).padStart(2, '0') + ':' +
    String(minutes).padStart(2, '0') + ':' +
    String(seconds).padStart(2, '0') +
    ampm
  );
}

async function loadWeather() {
  for (const city of cities) {
    try {
      const res = await fetch(`https://api.weatherapi.com/v1/current.json?key=${apiKey}&q=${encodeURIComponent(city.query)}`);
      const data = await res.json();

      const cityName = city.name.toUpperCase();
      const tempF = Math.round(data.current.temp_f);
      const condition = capitalizeWords(data.current.condition.text);
      const tz = data.location.tz_id; // e.g. "America/Chicago"

      const cityDiv = document.createElement('li');

      const nameEl = document.createElement('span');
      nameEl.textContent = cityName;

      const timeEl = document.createElement('span');

      const weatherEl = document.createElement('span');
      weatherEl.textContent = `${tempF}ºF and ${condition}`;

      cityDiv.appendChild(nameEl);
      cityDiv.appendChild(timeEl);
      cityDiv.appendChild(weatherEl);
      container.appendChild(cityDiv);

      // Use Intl.DateTimeFormat with timezone to get live local time
      function updateTime() {
        const now = new Date();
        const formatter = new Intl.DateTimeFormat('en-US', {
          hour12: false,
          timeZone: tz,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
        const parts = formatter.formatToParts(now);
        // Compose hh:mm:ss
        const h = parts.find(p => p.type === 'hour').value;
        const m = parts.find(p => p.type === 'minute').value;
        const s = parts.find(p => p.type === 'second').value;

        // Get AM/PM from 24h hour
        const hourNum = parseInt(h, 10);
        const ampm = hourNum >= 12 ? 'PM' : 'AM';
        const hour12 = hourNum % 12 || 12;

        timeEl.textContent = `${String(hour12).padStart(2, '0')}:${m}:${s}${ampm}`;
      }

      updateTime();
      setInterval(updateTime, 1000);

    } catch (err) {
      console.error('Error loading weather for', city.name, err);
    }
  }
}

loadWeather();

// Swiper

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.featured-carousel').forEach(carousel => {
    const swiperContainer = carousel.querySelector('.swiper-featured-carousel');
    const nextBtn = carousel.querySelector('.swiper-button-next');
    const prevBtn = carousel.querySelector('.swiper-button-prev');

    new Swiper(swiperContainer, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 20,
      breakpoints: {
        1200: {
          spaceBetween: 40,
        },
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      }
    });
  });

  const swiperProductGallery = new Swiper('.swiper-product-gallery', {
    loop: true,
    slidesPerView: "auto",
    speed: 600,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  var swiperCoverflow = new Swiper(".swiper-coverflow", {
    speed: 500,
    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: "auto",
    coverflowEffect: {
      rotate: 10,
      stretch: 0,
      depth: 400,
      modifier: 1,
      slideShadows: false,
    },
    mousewheel: {
      enabled: true,
      sensitivity: 2,
    },
    breakpoints: {
      992: {
        loop: true,
        coverflowEffect: {
          depth: 350,
        },
        freeMode: {
          enabled: true,
          sticky: true,
        },
      },
    },
  });

});

/**
 * Tabs
*/

document.querySelectorAll('.tabs-wrapper').forEach(wrapper => {
  const tabTriggers = wrapper.querySelectorAll('.tab-trigger');
  const tabContents = wrapper.querySelectorAll('.tab-content');

  function activateTab(tabTrigger) {
    tabTriggers.forEach(a => a.classList.remove("active"));
    tabTrigger.classList.add("active");

    tabContents.forEach(div => div.classList.remove("active"));

    const tab = tabTrigger.getAttribute("data-tab");
    const content = wrapper.querySelector(`.tab-content[data-tab="${tab}"]`);
    if (content) {
      content.classList.add("active");
    }
  }

  tabTriggers.forEach(tabTrigger => {
    if (tabTrigger.classList.contains("tab-trigger--click")) {
      tabTrigger.addEventListener("click", (event) => {
        event.preventDefault();
        activateTab(tabTrigger);
      });
    }

    if (tabTrigger.classList.contains("tab-trigger--hover")) {
      tabTrigger.addEventListener("mouseenter", (event) => {
        event.preventDefault();
        activateTab(tabTrigger);
      });
    }
  });
});

/**
 * Accordion
*/

const accordion = document.querySelector('.wm-accordion');
if (accordion) {
  document.addEventListener('DOMContentLoaded', () => {
    const headers = document.querySelectorAll('.accordion-header');

    headers.forEach(header => {
      header.addEventListener('click', () => {
        const parent = header.closest('.accordion-section');
        const content = header.nextElementSibling;
        const isOpen = parent.classList.contains('open');

        // Close all sections
        document.querySelectorAll('.accordion-section').forEach(section => {
          section.classList.remove('open');
        });

        document.querySelectorAll('.accordion-content').forEach(contentEl => {
          contentEl.style.maxHeight = '0';
        });

        // Open clicked section if it wasn't already open
        if (!isOpen) {
          parent.classList.add('open');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });

  });
}

/**
 * Product Page
*/

function initVariantSelectsSync() {
  const gallery = document.querySelector('media-gallery');
  const variantSelects = document.querySelector('variant-selects');
  const offsetElement = document.querySelector('.some-other-element'); // optional
  const minWidth = 992;
  const scrollThreshold = 40; // px scrolled before adding .scrolled

  if (!gallery || !variantSelects) return;

  /*const applyHeights = () => {
    if (window.innerWidth < minWidth) {
      variantSelects.style.height = '';
      variantSelects.classList.remove('scroll', 'scrolled');
      return;
    }

    const offset = offsetElement ? offsetElement.offsetHeight : 320;
    const galleryHeight = gallery.offsetHeight - offset;
    const variantHeight = variantSelects.scrollHeight;

    // Only run if variant section is taller than the media area
    if (variantHeight > galleryHeight) {
      variantSelects.style.height = `${galleryHeight}px`;
      variantSelects.classList.add('scroll');
    } else {
      variantSelects.style.height = '';
      variantSelects.classList.remove('scroll', 'scrolled');
    }
  };*/

  const applyHeights = () => {
    if (window.innerWidth < minWidth) {
      variantSelects.style.height = '';
      variantSelects.classList.remove('scroll', 'scrolled');
      return;
    }

    const offset = offsetElement 
      ? offsetElement.getBoundingClientRect().height 
      : 320;

    const galleryHeight = gallery.getBoundingClientRect().height - offset;
    const variantHeight = variantSelects.scrollHeight;

    // Force Safari reflow to ensure height sticks
    variantSelects.getBoundingClientRect();

    if (variantHeight > galleryHeight) {
      variantSelects.style.setProperty('height', `${galleryHeight}px`);
      variantSelects.classList.add('scroll');
    } else {
      variantSelects.style.height = '';
      variantSelects.classList.remove('scroll', 'scrolled');
    }
  };

  // Handle scroll within variantSelects
  variantSelects.addEventListener('scroll', () => {
    if (window.innerWidth < minWidth) return;
    variantSelects.classList.toggle('scrolled', variantSelects.scrollTop > scrollThreshold);
  });

  // Observe gallery for dynamic height changes
  const observer = new ResizeObserver(applyHeights);
  observer.observe(gallery);

  window.addEventListener('resize', applyHeights);
  window.addEventListener('load', applyHeights);

  applyHeights();
}

// ---- Main watcher to handle variant swaps ----
function watchForVariantChanges() {
  const container = document.querySelector('form[action*="/cart/add"]'); // parent wrapper
  if (!container) return;

  const observer = new MutationObserver(() => {
    if (document.querySelector('variant-selects') && document.querySelector('media-gallery')) {
      initVariantSelectsSync();
    }
  });

  observer.observe(container, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
  initVariantSelectsSync();
  watchForVariantChanges();
});

/**
 * Product Page Info Sections
*/

function initExpandableSections() {
  const minWidth = 992;

  // Define your sections and height thresholds here
  const sections = [
    { selector: '.product-section--tracklist', maxHeight: 540 },
    { selector: '.product-section--description', maxHeight: 400 }
  ];

  function checkHeights() {
    if (window.innerWidth < minWidth) {
      sections.forEach(({ selector }) => {
        const el = document.querySelector(selector);
        if (el) el.classList.remove('set-max-height', 'expanded');
      });
      return;
    }

    sections.forEach(({ selector, maxHeight }) => {
      const el = document.querySelector(selector);
      if (!el) return;

      if (el.scrollHeight > maxHeight) {
        el.classList.add('set-max-height');
      } else {
        el.classList.remove('set-max-height', 'expanded');
      }
    });
  }

  // Handle toggle clicks
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.read-more-toggle');
    if (!toggle) return;

    // Find the nearest target section (next sibling or matched section)
    const section =
      toggle.previousElementSibling?.classList.contains('product-section--tracklist') ||
      toggle.previousElementSibling?.classList.contains('product-section--description')
        ? toggle.previousElementSibling
        : document.querySelector(toggle.dataset.target);

    if (section) {
      section.classList.toggle('expanded');
    }
  });

  // Check on load and resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkHeights, 150);
  });
  window.addEventListener('load', checkHeights);

  checkHeights();
}

document.addEventListener('DOMContentLoaded', initExpandableSections);

/**
 * Filters
*/

const filterToggle = document.querySelector('.filter-toggle');
if(filterToggle) {
  filterToggle.addEventListener("click", (event) => {
    pageBody.classList.toggle("filters-open");
  });
}

/**
 * Mobile Search
*/

const searchToggle = document.querySelector('.search-toggle');
if(searchToggle) {
  searchToggle.addEventListener("click", (event) => {
    pageBody.classList.toggle("search-open");
    if(pageBody.classList.contains("search-open")) {
      setTimeout(() => {
        document.querySelector(".search__input").focus();
      }, "10");
    }
  });
}

/**
 * Predictive Search
*/

document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.querySelector('.search__input');
  if (!searchInput) return;

  // Find a stable parent that always exists
  const resultsWrapper = document.querySelector('.search-modal__form') || document.body;
  if (!resultsWrapper) return;

  function insertSeeAllButton() {
    const topResults = resultsWrapper.querySelector('.search-results-group--top');
    if (!topResults) return;

    let seeAllBtn = topResults.querySelector('.see-all-results');
    if (!seeAllBtn) {
      seeAllBtn = document.createElement('a');
      seeAllBtn.className = 'btn see-all-results';
      seeAllBtn.textContent = 'See All';
      topResults.appendChild(seeAllBtn);
    }

    const query = encodeURIComponent(searchInput.value.trim());
    seeAllBtn.href = `/search?q=${query}`;
  }

  // Observe all changes in resultsWrapper
  const observer = new MutationObserver(() => {
    insertSeeAllButton();
  });

  observer.observe(resultsWrapper, { childList: true, subtree: true });

  // Also update href on typing
  searchInput.addEventListener('input', insertSeeAllButton);
});


/**
 * Mobile Menu
*/

const menuToggle = document.querySelector('.menu-toggle');
if(menuToggle) {
  menuToggle.addEventListener("click", (event) => {
    pageBody.classList.toggle("menu-open");
  });
}

const siteMenu = document.querySelector('.site-menu');

// Handle forward navigation (into submenus)
siteMenu.addEventListener('click', (e) => {
  const trigger = e.target.closest('.js-menu-slider');
  if (!trigger) return;

  e.preventDefault();
  const menuLabel = trigger.textContent.trim();

  if (trigger.closest('.site-menu--level-1')) {
    document.querySelector('.menu-back-l1').textContent = menuLabel;
    siteMenu.classList.add('level-2-open');

    const key = trigger.dataset.subMenu;
    const subMenus = document.querySelectorAll('.site-menu--level-2 ul');
    subMenus.forEach(sM => sM.style.display = "none");
    document.querySelector(`.site-menu--level-2 ul[data-sub-menu="${key}"]`).style.display = "block";

  } else if (trigger.closest('.site-menu--level-2')) {
    document.querySelector('.menu-back-l2').textContent = menuLabel;
    siteMenu.classList.add('level-3-open');

    const key = trigger.dataset.subMenu;
    const subMenus = document.querySelectorAll('.site-menu--level-3 ul');
    subMenus.forEach(sM => sM.style.display = "none");
    document.querySelector(`.site-menu--level-3 ul[data-sub-menu="${key}"]`).style.display = "block";

  }

});

// Handle back navigation (out of submenus)
siteMenu.addEventListener('click', (e) => {
  if (e.target.matches('.menu-back-l1')) {
    e.preventDefault();
    siteMenu.classList.remove('level-2-open');
  } else if (e.target.matches('.menu-back-l2')) {
    e.preventDefault();
    siteMenu.classList.remove('level-3-open');
  }
});

// LOAD LAST

document.addEventListener('DOMContentLoaded', function () {

  // Swiper carousel
  const swiperHero = new Swiper('.swiper-hero', {
    rewind: true,
    slidesPerView: 1,
    autoHeight: false,
    simulateTouch: false,
    effect: "fade",
    speed: 600,
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: updateBackgroundColor,
      slideChangeTransitionStart: updateBackgroundColor,
    }
  });

  const swiperHeroImages = new Swiper('.swiper-hero-images', {
    rewind: true,
    slidesPerView: "auto",
    spaceBetween: 30,
    slidesOffsetAfter: 30,
    slidesOffsetBefore: 30,
    simulateTouch: false,
    breakpoints: {
      1200: {
        slidesOffsetBefore: 0,
        spaceBetween: 40,
        slidesOffsetAfter: 40,
      },
    },
    on: {
      init: updateBackgroundColor,
      slideChangeTransitionStart: updateBackgroundColor,
    }
  });

  function updateBackgroundColor(swiperHero) {
    const activeSlide = swiperHero.slides[swiperHero.activeIndex];
    const bgColor = activeSlide.getAttribute('data-bg-color');
    const textColor = activeSlide.getAttribute('data-text-color');
    const btnUrl = activeSlide.getAttribute('data-btn-url');

    if (btnUrl) {
      document.querySelector('.hero-carousel .carousel-controls .btn').href = btnUrl;
    }
    
    if (bgColor) {
      if(textColor == 'White') {
        document.querySelector('.hero-carousel').classList.add('light');
      } else {
        document.querySelector('.hero-carousel').classList.remove('light');
      }
      document.querySelector('.hero-carousel').style.background = bgColor;
    } else {
      document.querySelector('.hero-carousel').style.background = "#ffffff";
    }
  }

  swiperHero.controller.control = swiperHeroImages;
  swiperHeroImages.controller.control = swiperHero;

});